import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getRole } from 'api/Roles';

export const useRole = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['getRole', ...dependencies], () => getRole(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...options
  });
};
